export default __webpack_public_path__ + "static/wika-26ead15eb80e93d516633b87a26d15db.webp";